import type { FunctionComponent } from 'react';

import { useLayout } from '../../main/util/layout-context';
import { BannerCollection } from '../../shared/components/banner-collection/banner-collection';
import { createClassName, createStyleHelper } from '../../shared/utils/class-names';
import { MerchandiseIf } from '../components/merchandiseIf';

import styles from './merchandise.module.scss';

const style = createStyleHelper(styles, 'merchandise');
export interface MerchandiseProps {
    className?: string;
}

export const Merchandise: FunctionComponent<MerchandiseProps> = ({ className }) => {
    useLayout({
        title: 'Merch',
        showNavButtons: true,
        isFullWidth: true,
    });

    return (
        <>
            {prompt}
            <div className={createClassName([className, style()])}>
                <BannerCollection page="casino" type="lobby" />
                <h1 className={style('label')}>MERCH</h1>
                <MerchandiseIf />
            </div>
        </>
    );
};
